import {buildAsyncActionsCreator, createAsyncActionExecutor} from '../asyncUtils';
import {requestModelStewardSet} from './api';
import {ModelStewardActions} from './types';

const modelStewardSetActionsCreator = buildAsyncActionsCreator(ModelStewardActions.SET);
export const modelStewardSet = createAsyncActionExecutor(modelStewardSetActionsCreator, requestModelStewardSet);
